import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The Structure tab: the scene tree and the metadata of the selected node. The page owns the state; this component
 * only renders it, so it is checked with the page.
 */
@Component({
  selector: 'section[viewer-scene-tree-panel]',
  templateUrl: './viewer-scene-tree-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerSceneTreePanelComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;
}
